<template>
<svg
    :class="className"
    xmlns="http://www.w3.org/2000/svg">
    <title v-if="title">{{ title }}</title>
    <use :href="`#${name}`"></use>
</svg>
</template>

<script>
require.context("../assets/svg", false, /\.svg(?:\?.*)?$/);
export default {
    props: {
        name: { type: String, required: true },
        title: { type: String, default: null }
    },
    computed: {
        className() {
            return `svg-icon svg-icon--${this.name}`;
        }
    }
};
</script>

<style>
.svg-icon {
    display: inline-block;
}
</style>
